import { GET_ASYNC } from "../helpers/httpHelper";

const BASE_PATH = 'api/File';

export interface IFileResponse {
    success: boolean;
	url?: string;
	error?: string;
}


const getSignedUrl = async (key: string): Promise<IFileResponse> => {
    try {
        const response = await GET_ASYNC(`${BASE_PATH}/SignedUrl?key=${key}`);

        if (response && response.success) {
            return { success: response.success, url: response.entity };
        } else {
            return { success: response.success, error: response.message };
        }
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

const getEvidenceImageUrl = async (key: string): Promise<IFileResponse> => {
    try {
        const response = await GET_ASYNC(`${BASE_PATH}/EvidenceImage?key=${key}`);

        if (response && response.success) {
            return { success: response.success, url: response.entity };
        } else {
            return { success: response.success, error: response.message };
        }
    } catch (err: any) {
        return { success: false, error: err.message };
    }
};

export default {
    getSignedUrl,
    getEvidenceImageUrl,
};